import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AnalyticsService } from '../../services/analytics.service';
import { HttpClient } from '@angular/common/http';

@Component({
    standalone: false,
    selector: 'app-loading-modal',
    templateUrl: './loading-modal.component.html',
    styleUrls: ['./loading-modal.component.scss'],
})
export class LoadingModalComponent implements OnInit {
    public items: any = [];
    constructor(
        private _analytics: AnalyticsService,
        public dialogRef: MatDialogRef<LoadingModalComponent>,
        private http: HttpClient,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        dialogRef.disableClose = true;
    }

    ngOnInit() {}
}
